import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import moment from "moment";
import { exportMultipleChartsToPdf, generateExcel } from "../../../../utils/pdf";
import { EXLDownloadIcon, PDFDownloadIcon } from "../../../../SvgIconsData";
import { ArrowUpDown} from "../../../../assets/icons/iconshere";
import Skeleton from "react-loading-skeleton";
import ProPopup from "../../../layouts/ProPopup";

const UserReport = ({groupId , dates}) => {
  
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [userReportData, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [userPlan, setUserPlan] = useState(null);
  const [openPro, setOpenPro] = useState(false);

  useEffect(() => {
    userPlan && !userPlan.report.group && setOpenPro(true);
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userPlan]);

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const sortedUserData = () => {
    let sortedData = [...userReportData];
    if (sortBy) {
      sortedData.sort((a, b) => {
        if (a[sortBy] < b[sortBy]) return sortOrder === "asc" ? -1 : 1;
        if (a[sortBy] > b[sortBy]) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortedData;
  };

  const getUsersList = async () => {
    try {
      setLoading(true);
      let url = `${configData.config.API_URL}/api/analytics/locationWiseUserReport/${groupId}`;
      if (dates.start && dates.end) {
        url += `?start=${dates.start.toISOString()}&end=${dates.end.toISOString()}`;
      }
      let { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });
      setUserData(data.data || []);
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false);
    }
  };

  const getLocationWiseUserModulesData = (userUuid) => {
    return axios.get(`${configData.config.API_URL}/api/analytics/locationWiseUserModuleWise/${groupId}}/${userUuid}`,
        {headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          }}) 
         };
     
  const handleUserPdf = async(userUuid, name, guided, unguided, certificates) => {
    try{
        let {data} = await getLocationWiseUserModulesData(userUuid)

        const tableData1 = [
          ["User DashBoard", ""],
          ["Name", name],
          ["Trainings", guided],
          ["Assessments", unguided],
          ["Certificates", certificates],
        ];

        let arr = [];

        data.data.map((item, index) => {
          arr.push([
            index + 1,
            item.resource.name,
            item.mode,
            moment(item.startTime).format("DD/MM/YYY hh:mm a"),
            item.additionalId
              ? item.additionalId.charAt(0).toUpperCase() + item.additionalId.slice(1)
              : "",
          ]);
        });

        const tableData2 = [["S.No.", "Project", "Mode", "Timestamp", "Language"], ...arr];

        exportMultipleChartsToPdf("User_Location_Wise", tableData1, tableData2);
      }catch(error){
        console.error(error);
      };
  };

  const handleUserExcel = async(userUuid, name, guided, unguided, certificates) => {
    try {
       let { data } =  await getLocationWiseUserModulesData(userUuid);
       const tableData1 = [
         ["User DashBoard", ""],
         ["Name", name],
         ["Trainings", guided],
         ["Assessments", unguided],
         ["Certificates", certificates],
       ]
        let arr = [];
        data.data.map((item, index) => {
          arr.push([
            index + 1,
            item.resource.name,
            item.mode,
            moment(item.startTime).format("DD/MM/YYY hh:mm a"),
            item.additionalId
              ? item.additionalId.charAt(0).toUpperCase() + item.additionalId.slice(1)
              : "",
          ]);
        });
        const tableData2 = [["S.No.", "Project", "Mode", "Timestamp", "Language"], ...arr];
        generateExcel("User_Location_Wise", tableData1, tableData2);  
      } catch (error) {
        console.log(error);
      }

  };

  useEffect(() => {
    if(userPlan?.report?.user){
      getUsersList();
    }
  }, [userPlan, groupId, dates]);

  return (
    <>
        <div className="table-responsive workflowtb mt-2 stickyhead reports">
          <table className="table align-middle table-nowrap mb-0">
            <thead>
              <tr>
                <th>
                  <div className="text-center">S.No.</div>
                </th>
                <th>
                  <span className="d-flex align-items-center justify-content-start gap-2">
                    Name
                    <span onClick={() => handleSort("name")} style={{ marginTop:"-2px" }}>
                      <ArrowUpDown />
                    </span>
                      
                  </span>
                </th>
                <th className="text-center">
                  <span
                    className="d-flex align-items-center justify-content-center gap-2"
                    onClick={() => handleSort("guided")}>
                    Guided Count
                    <span style={{ marginTop:"-2px" }}>
                      <ArrowUpDown />
                    </span>
                      
                  </span>
                </th>
                <th className="text-center">
                  <span
                    className="d-flex align-items-center justify-content-center gap-2"
                    onClick={() => handleSort("unguided")}>
                    Unguided Count
                    <span style={{ marginTop:"-2px" }}>
                      <ArrowUpDown />
                    </span>
                    
                  </span>
                </th>
                <th className="text-center">
                  <span
                    className="d-flex align-items-center justify-content-center gap-2"
                    onClick={() => handleSort("certificate")}>
                    Certfications
                    <span style={{ marginTop:"-2px" }}>
                      <ArrowUpDown />
                    </span>
                    
                  </span>
                </th>
                <th className="text-center">
                  <span className="d-flex align-items-center justify-content-center gap-2">
                    Download
                  </span>
                </th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                 Array.from({length:4}).map((_,index)=>(
                  <tr key={index} >
                    {Array.from({length:5}).map((_, index)=> <td> <Skeleton width="5vw" /> </td> )}
                    <td className="d-flex align-items-center justify-content-center gap-2">
                      <Skeleton
                        width="40px"
                        height="33px"
                        baseColor="#3e4095"
                        highlightColor="#ffffff50"
                      />
                      <Skeleton
                        width="40px"
                        height="33px"
                        baseColor="#3e4095"
                        highlightColor="#ffffff50"
                      />
                    </td>
                  </tr>
                 ))
              ) : (
                <>
                  {sortedUserData().map((item, index) => (
                    <tr key={item.id}>
                      <td>
                        <div className="text-center">{index + 1}</div>
                      </td>
                      <td>{item.name}</td>
                      <td className="text-center">{item.guided}</td>
                      <td className="text-center">{item.unguided}</td>
                      <td className="text-center">{item.certificate?.length || 0}</td>
                      <td className="d-flex align-items-center justify-content-center gap-2">
                        <button
                          className="DefaultRedBtn download px-2"
                          title="Download PDF"
                          onClick={() =>  userPlan?.report?.download ? 
                            handleUserPdf(
                              item.uuid,
                              item.name,
                              item.guided,
                              item.unguided,
                              item.certificate.length
                            ) :
                            setOpenPro(true)
                          }>
                          <PDFDownloadIcon />
                        </button>
                        <button
                          className="DefaultRedBtn download px-2"
                          title="Download Excel"
                          onClick={() => userPlan?.report?.download ? handleUserExcel(item.uuid, item.name) : setOpenPro(true) }>
                          <EXLDownloadIcon />
                        </button>
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>

            <thead className="bottom-stuck">
              {loading ? 
                <tr style={{ borderBottom: "2px solid #33333350 !important" }}>
                {Array.from({length:5}).map((_, index)=> <td className="text-center"> <Skeleton width="5vw" /> </td> )}
                <td className="d-flex align-items-center justify-content-center gap-2">
                    <Skeleton width="5vw" />
                   {/* <Skeleton
                        width="40px"
                        height="33px"
                        baseColor="#3e4095"
                        highlightColor="#ffffff50"
                      />
                      <Skeleton
                        width="40px"
                        height="33px"
                        baseColor="#3e4095"
                        highlightColor="#ffffff50"
                      /> */}
                </td>
              </tr>
              :
              <tr style={{ borderBottom: "2px solid #33333350 !important" }}>
                <td className="text-center"> </td>
                <td> Total </td>
                <td className="text-center"> {userReportData.reduce((acc, current) => acc + current?.guided, 0) || 0} </td>
                <td className="text-center"> {userReportData.reduce((acc, current) => acc + current?.unguided, 0) || 0}</td>
                <td className="text-center"> {userReportData.reduce( (acc, current) => acc + current?.certificate?.length, 0 ) || 0}  </td>
                <td className="text-center"> </td>
                {/* <td className="d-flex align-items-center justify-content-center gap-2">
                <button
                      className="DefaultRedBtn download px-2"
                      title="Download PDF"
                >
                <PDFDownloadIcon />
                </button>

                <button
                  className="DefaultRedBtn download px-2"
                  title="Download Excel"
                  >
                  <EXLDownloadIcon />
                </button>
                </td> */}
              </tr>
              }
            </thead>
          </table>
        </div>

        <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
    </>
  );
};

export default UserReport;